import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { FaCheckCircle } from 'react-icons/fa';
import { useAssessmentsDataContext } from '../../providers/assessments-data-provider';

const styles = {
  selected: {
    color: 'white',
    backgroundColor: '#5cbfe6',
  },
  nonSelected: {
    color: 'black',
    backgroundColor: 'white',
  },
  hover: {
    color: 'black',
    backgroundColor: '#e9ecef',
  },
};

function SelfPacedAnswerSelection({ question }) {
  const { checkAnswersForPage } = useAssessmentsDataContext();
  const [selected, setSelected] = useState(-1);
  const [hoverIndex, setHoverIndex] = useState(-1);

  const q = question.question;

  const mouseEnter = (e, key) => {
    const event = { ...e };
    if (key !== selected) {
      event.target.style.cursor = 'pointer';
      setHoverIndex(key);
    } else {
      event.target.style.cursor = '';
    }
  };

  const mouseLeave = (e, key) => {
    if (key !== selected) {
      const event = { ...e };
      event.target.style.cursor = '';
      setHoverIndex(-1);
    }
  };

  const onClick = (key) => {
    if (selected === key) {
      setSelected(-1);
    }
    q.answer = key;
    setSelected(key);
    checkAnswersForPage();
  };

  const getStyle = (key) => {
    if (selected === key) {
      return styles.selected;
    }
    if (hoverIndex === key) {
      return styles.hover;
    }
    return styles.nonSelected;
  };

  const circleProps = useMemo(
    () => ({
      color: 'grey',
      className: 'global-class-name',
      size: '1em',
    }),
    []
  );

  useEffect(() => {
    if (q.answer) {
      setSelected(q.answer);
    }
  }, [q.answer]);

  const location = useLocation();

  return (
    <>
      {q.question.anchoring.items.map((item) => (
        <>
          {!location.pathname.startsWith('/assessments/competencies') && (
            <Row
              key={item.id}
              className="w-75 mx-auto border border-dark border-opacity-25 pt-4 pb-4 mt-2"
              style={getStyle(item.id)}
              onMouseOver={(event) => {
                mouseEnter(event, item.id);
              }}
              onMouseLeave={(event) => {
                mouseLeave(event, item.id);
              }}
              onClick={() => {
                onClick(item.id);
              }}
            >
              <Col xs={1} className="d-flex justify-content-start align-items-center me-3" style={getStyle(item.id)}>
                <div>
                  {selected === item.id && (
                    <IconContext.Provider value={circleProps}>
                      <div>
                        <FaCheckCircle color="white" />
                      </div>
                    </IconContext.Provider>
                  )}
                </div>
              </Col>
              <Col className="d-flex justify-content-start align-items-center p-2 me-2">
                <div className="selection-text">{item.body}</div>
              </Col>
            </Row>
          )}
          {location.pathname.startsWith('/assessments/competencies') && (
            <Row
              key={item.id}
              className="w-75 mx-auto border border-dark border-opacity-25 pt-4 pb-4 mt-2"
              style={getStyle(item.id)}
              onMouseOver={(event) => {
                mouseEnter(event, item.id);
              }}
              onMouseLeave={(event) => {
                mouseLeave(event, item.id);
              }}
              onClick={() => {
                onClick(item.id);
              }}
            >
              <Col xs={1} className="d-flex justify-content-start align-items-center me-3" style={getStyle(item.id)}>
                <div>
                  {selected === item.id && (
                    <IconContext.Provider value={circleProps}>
                      <div>
                        <FaCheckCircle color="white" />
                      </div>
                    </IconContext.Provider>
                  )}
                </div>
              </Col>
              <Col className="d-flex justify-content-start align-items-center p-2 me-2">
                {item.header ? (
                  <div className="selection-text">
                    <span className="text-bold pe-2">{item.header}:</span>
                    {item.body}
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-content-center selection-text">{item.body}</div>
                )}
              </Col>
            </Row>
          )}
        </>
      ))}
    </>
  );
}

export default SelfPacedAnswerSelection;
